import React from 'react';
import './Contact.css'
import github from '../../../src/img/social/images.png'
import website from '../../../src/img/social/website.png'
import linkedin from '../../../src/img/social/linkedin.png'

const Contact = () => {
    return (
        <div id="contact">

          <h1 className="contact-title">Contact with me</h1>
            <div className="background">
  <div className="container">
    <div className="screen">
      <div className="screen-header">
        <div className="screen-header-left">
          <div className="screen-header-button close"></div>
          <div className="screen-header-button maximize"></div>
          <div className="screen-header-button minimize"></div>
        </div>
        <div className="screen-header-right">
          <div className="screen-header-ellipsis"></div>
          <div className="screen-header-ellipsis"></div>
          <div className="screen-header-ellipsis"></div>
        </div>
      </div>
      <div className="screen-body">
        <div className="screen-body-item left">
          <div className="app-title">
            <span>CONTACT</span>
            <span>With me</span>
          </div>
          <div className="app-contact">CONTACT INFO : +8801758224633</div>
        </div>
        <div className="screen-body-item">
          <div className="app-form">
            <div className="app-form-group">
              <input className="app-form-control" placeholder="NAME" value=""/>
            </div>
            <div className="app-form-group">
              <input className="app-form-control" placeholder="EMAIL"/>
            </div>
            <div className="app-form-group">
              <input className="app-form-control" placeholder="CONTACT NO"/>
            </div>
            <div className="app-form-group message">
              <input className="app-form-control" placeholder="MESSAGE"/>
            </div>
            <div className="app-form-group buttons">
              <button className="app-form-button">CANCEL</button> <br/>
              <button className="app-form-button">SEND</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="credits">
    
        
      
    </div>
  </div>
</div>


<footer class="footer-distributed">
                
                <div class="footer-left">
                
                <h3>Shahin<span>Shah</span></h3>
                
                <p class="footer-links">
                <a href="#">Home</a>
                ·

                <a href="/blogs">Blog</a>
                ·
              
                ·
                <a href="#">About</a>
                ·
                
                ·
                <a href="#">Contact</a>
                </p>
                
                <p class="footer-company-name">Shahin Shah &copy; 2021</p>
                </div>
                
                <div class="footer-center">
                
                <div>
                <i class="fa fa-map-marker"></i>
                <p><span>Road 4</span> Shyamoli, Bangladesh</p>
                </div>
                
                <div>
                <i class="fa fa-phone"></i>
                <p>+8801758224633</p>
                </div>
                
                <div>
                <i class="fa fa-envelope"></i>
                <p><a href="shah1721510044@gmail.com">shah1721510044@gmail.com</a></p>
                </div>
                
                </div>
                
                <div class="footer-right">
                
                <p class="footer-company-about">
                <span>About me</span>
                    I am a mern-stack developer
                </p>
                
                <div class="footer-icons">
                
                <a className="mx-3" target="_blank" href="https://github.com/shahin1122"><img className="w-100 " src={github} alt=""/></a>
                <a className="mx-3" target="_blank" href="https://www.linkedin.com/in/shahin-shahhh/"><img className="w-100 " src={linkedin} alt=""/></a>
                <a className="mx-3" target="_blank" href="https://my-portfolio-52896.web.app/"><img className="w-100 " src={website} alt=""/></a>
               
                
                
                </div>
                
                </div>
                
                </footer>



            
        </div>
    );
};

export default Contact;